import { render, staticRenderFns } from "./EmailSendFile.vue?vue&type=template&id=378739e3&scoped=true&"
import script from "./EmailSendFile.vue?vue&type=script&lang=js&"
export * from "./EmailSendFile.vue?vue&type=script&lang=js&"
import style0 from "./EmailSendFile.vue?vue&type=style&index=0&id=378739e3&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378739e3",
  null
  
)

export default component.exports